/* eslint-disable import/no-unresolved */

module.exports = require('./lib/react');
